import { UtilityMethods } from "@mindmemobile/mm-shared-global";
import { IAPIItemDetailPageCommonModel } from "../interfaces";
import { CategoryModel } from "./CategoryModels";
import { MediaModel } from "./MediaModel";

 
 
export class ItemDetailPageModel {
    id: string;
    name: string;
    isActive: boolean;
    description: string;
    category: CategoryModel | null;
    surcharge: boolean;
    discount: boolean;
    review: boolean;
    tax: boolean;
    return: boolean;
    hasVariants: boolean;
    sku: string;
    taxId: string;
    barCode: string;
    medias: MediaModel[];
    returnDays: number;
    createdDate?: Date | null | undefined;
    constructor(data?: Partial<ItemDetailPageModel>) {
        this.id = (data && data.id) || '';
        this.name = (data && data.name) || '';
        this.isActive = (data && data.isActive) || false;

        if (!data) {
            this.isActive = true;
        }
        this.category = (data && data.category) || null;
        this.sku = (data && data.sku) || '';
        this.barCode = (data && data.barCode) || '';
        this.discount = (data && data.discount) || false;
        this.surcharge = (data && data.surcharge) || false;
        this.tax = (data && data.tax) || false;
        this.return = (data && data.return) || false;
        this.review = (data && data.review) || false;
        this.hasVariants = (data && data.hasVariants) || false;
        this.description = (data && data.description) || '';
        this.medias = (data && data.medias) || [];
        this.returnDays = data?.returnDays || 0;
        this.taxId = (data && data.taxId) || '';
        this.createdDate = data?.createdDate;
    }

    static deserializeAPIModel(data: IAPIItemDetailPageCommonModel): ItemDetailPageModel {
        return new ItemDetailPageModel({
            id: data.id,
            name: data.name,
            isActive: data.isActive,
            description: data.description,
            category: data.category ? CategoryModel.deserializeAPIModel(data.category) : null,
            discount: data.discount,
            tax: data.tax,
            review: data.review,
            return: data.return,
            returnDays: data.returnDays,
            sku: data.sku,
            barCode: data.barCode,
            surcharge: data.surcharge,
            hasVariants: data.hasVariants,
            medias: data.medias.map((m) => MediaModel.deserializeAPIModel(m)),
            taxId: data.taxId,
            createdDate: data.createdDate ? UtilityMethods.removeZFromDateString(data.createdDate) : null,
        });
    }
}
